import * as React from "react";
import styled from "styled-components";
import { Button } from "@mui/material";
import Auth from "src/services/auth";
import request from "src/utils/request";
import { useAuth } from "src/components/providers/auth-context";
import UpgradeCard from "./upgrade-card";
import { getRedirectUrl } from "./utils";

const H2 = styled.h2`
    font-size: 35px;
    margin: 0;
    font-weight: 600;
    color: ${({ theme }) => theme.palette.text.secondary};
`;

const CurrencySymbol = styled.span`
    font-size: 20px;
    margin: 0;
    font-weight: 300;
    color: ${({ theme }) => theme.palette.text.secondary};
`;

const PerUser = styled.span`
    font-size: 12px;
    margin: 0;
    font-weight: 400;
    color: ${({ theme }) => theme.palette.text.secondary};
`;

const Price = () => (
    <H2>
        10<CurrencySymbol>$</CurrencySymbol>
    </H2>
);

const Period = () => <PerUser>/month</PerUser>;

const Action = () => {
    const { isDemo } = useAuth();
    const locationPrefix =
        window.location.hostname === "demo.adadot.com" ? "https://sit.adadot.com" : "";

    const getAction = async (e: React.SyntheticEvent<HTMLFormElement>) => {
        e.preventDefault();
        const url = await request<string>(
            `${locationPrefix}/api/payments/create-checkout-session/personal?redirect_uri=${getRedirectUrl()}`,
            { method: "POST", body: JSON.stringify({ lookup_key: "pro_plan" }) }
        );
        window.location.replace(url);
    };

    return (
        <form onSubmit={getAction}>
            <input type="hidden" name="lookup_key" value="pro_plan" />
            <Button
                id="checkout-and-portal-button"
                variant="contained"
                type="submit"
                color="primary"
                fullWidth
                onClick={(e) => {
                    if (isDemo) {
                        e.preventDefault();
                        Auth.redirectToLogin();
                    }
                }}
                style={{ fontWeight: "bold" }}
            >
                trial pro plan
            </Button>
        </form>
    );
};

const UpgradeCardPro = () => {
    return (
        <UpgradeCard
            listItems={["Personal Dashboards", "Unlimited data history", "Support"]}
            listStartItem={null}
            pricingItems={[Price, Period]}
            title="personal pro"
            Action={Action}
            subtitle=""
        />
    );
};

export default UpgradeCardPro;
